// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-12-11T11:33:22+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190785
//    Project:        617
//    Environment:    7626 - master
//    MD5:            098465ba842e1b1d4458d294031fde4b
//    Signature:      eyJpdiI6IkNTb0JocWZPT0dxUzRWVlpVRXN3U0E9PSIsInZhbHVlIjoiMkl2aDA2TlptRHhSOVVENzJJYUxxWXB4TGVYeHV6c1lPcVFpQ0JiR0srVzBVYlpRN1htSWh6VjZCemFIWDRSWWJqYTZjMzRrY2l1b0I1SjZIMENcL0tlMFwvSWx5N2NiaG42OU1lTVwveUFXK1RneEpjTkZVVVFad0tyWk1ERWdBSmRhc0F5dHRJNjh0bDgwaWlwaDliVzkzaWUzRjI0Tk9saythRmEyMlhEVUp5SmJLQnViMU9Gd3dDb0o1RWY2aDlSZnZGdkFydTdIZTYrQjFGZUMzSThxNVZPdDZpM3hZN2NrbFwvcnc4dU0rVUlNa29QOW1uc2JHRGROb3pcL25TZE5FbkdZd2FEXC9iYVMxeGV2aExGVFF3Z3hRNmViZ24zRmhKcWY4ZXRkVDZaZzhSUjZ6SXQ3NCs2aVl2RU50bHFYNFB2dmwwZ3AxbUQ1eUJPWDFEZitWd3p3QmFYWW1kbzBPMUhST0Z4UXY4eDhFMjdqY25NMGtKdHFMNk51eE1FVDdHaHphQ282akVvTzJYR051c1AwUklXUT09IiwibWFjIjoiNDgwZjkxMTdhNDEwYzc1NjRjMTQ0ZDc5MTJkNmE0ZTlkZDJhZGJjZTJiOWMzNjdlMmQyZTYyMGZjN2VmZjc5NyJ9
class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
